import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { UXPContext } from '@core/context/Context';
import Checkbox from '@widget/forms/inputs/Checkbox';
import Chip from '@widget/other/Chip';
/**
 * @export
 * A bordered list of choices with checkboxes, and an optional "Select all" row first.
 *
 * @example
 * ```
 * <CheckboxList
 *   title="Linked dashboards"
 *   items={[{ id: 'db2', label: 'Single Dashboard', description: 'db2' }]}
 *   selected={picked}
 *   onChange={setPicked}
 * />
 * ```
 *
 * @category Forms
 */
const CheckboxList = ({ items, selected, onChange, title, showSelectAll = true, selectAllLabel, showCount = true, emptyText, className, }) => {
    const context = useContext(UXPContext);
    const ticked = items.filter((item) => selected.includes(item.id));
    const pickable = items.filter((item) => !item.disabled);
    const allState = ticked.length === 0 ? false : ticked.length === items.length ? true : 'intermediate';
    const toggle = (id, checked) => onChange(checked ? [...selected.filter((s) => s !== id), id] : selected.filter((s) => s !== id));
    const toggleAll = (checked) => {
        const keep = selected.filter((id) => items.some((item) => item.id === id && item.disabled));
        onChange(checked ? [...keep, ...pickable.map((item) => item.id).filter((id) => !keep.includes(id))] : keep);
    };
    return (_jsxs("div", { className: ['uxpcore_checkboxlist', className].filter(Boolean).join(' '), children: [title && _jsx("div", { className: "uxpcore_checkboxlist__title", children: title }), items.length === 0 ? (emptyText ? _jsx("div", { className: "uxpcore_checkboxlist__empty", children: emptyText }) : null) : (_jsxs("div", { className: "uxpcore_checkboxlist__list", children: [showSelectAll && items.length > 1 && (_jsxs("div", { className: "uxpcore_checkboxlist__row uxpcore_checkboxlist__row--all", children: [_jsx(Checkbox, { checked: allState, onChange: toggleAll, label: selectAllLabel || context.$L('uxp-core.text.select-all') }), showCount && (_jsx("span", { className: "uxpcore_checkboxlist__count", children: context.$L('uxp-core.text.x-of-y-selected', {
                                    selected: String(ticked.length),
                                    total: String(items.length),
                                }) }))] })), items.map((item) => (_jsxs("div", { className: "uxpcore_checkboxlist__row", children: [_jsx(Checkbox, { checked: selected.includes(item.id), onChange: (checked) => toggle(item.id, checked), disabled: item.disabled, label: _jsxs("span", { className: "uxpcore_checkboxlist__label", children: [_jsx("span", { className: "uxpcore_checkboxlist__name", children: item.label }), item.description && (_jsx("span", { className: "uxpcore_checkboxlist__description", children: item.description }))] }) }), item.tag && _jsx(Chip, { label: item.tag.label, variant: item.tag.variant || 'secondary', size: "small" })] }, item.id)))] }))] }));
};
export default CheckboxList;
